import {NfMessage, NfMessageType} from "../NfMessage";
import type {CalculationModel} from "../Models/CalculationModel";
import {NfGlobalMessage} from "../NfGlobalMessage";

/**
 * Wiadomość, gdy przyszła kalkulacja kosztów
 */
export class GetReservationCalculationResult extends NfGlobalMessage {
    private calculation: any;
    declare public reservationUniqueId: number;
    public constructor(calculation: CalculationModel|MessageEvent<GetReservationCalculationResult>, reservationUniqueId?: number) {
        super(NfMessageType.GetReservationCalculationResult, arguments.length > 1);
        this.persistentMessage = true;
        if(NfMessage.isMessageEvent(calculation)) {
            Object.assign(this, calculation.data);
        } else {
            this.calculation = this.serialize(calculation);
            if (!reservationUniqueId) {
                throw Error('reservationUniqueId jest wymagany');
            }
            this.reservationUniqueId = reservationUniqueId;
        }
    }
    public getCalculation():CalculationModel {
        return this.deserialize(this.calculation);
    }
}
NfMessage.creationCallbacks[NfMessageType.GetReservationCalculationResult] = (event) => {
    return new GetReservationCalculationResult(event);
}
